import React from 'react';
import { useStyle } from 'react-native-style-utilities';
import type { HeaderTitleProps } from '@react-navigation/elements';

import { BodyText } from '../../Text';

export const HeaderTitle = ({ children, tintColor }: HeaderTitleProps) => {
  const dynamicStyle = useStyle(() => ({ color: tintColor }), [tintColor]);

  return (
    <BodyText testID="sg-scrollview.header.title" size={1} style={dynamicStyle}>
      {children}
    </BodyText>
  );
};
